import { ServiceHandler } from '../../../utils/api.utils';
import type {
  Conversation,
  ConversationsListResponse,
  CreateConversationRequest,
} from '../types';

export const getConversations = ServiceHandler<unknown, ConversationsListResponse>({
  url: '/api/chat-agent/v1/conversations',
});

export const getConversation = ServiceHandler<unknown, Conversation>({
  url: '/api/chat-agent/v1/conversations/:conversationId',
});

export const createConversation = ServiceHandler<CreateConversationRequest, Conversation>({
  url: '/api/chat-agent/v1/conversations',
  method: 'POST',
});

export const deleteConversation = ServiceHandler<unknown, void>({
  url: '/api/chat-agent/v1/conversations/:conversationId',
  method: 'DELETE',
});
